import React from "react";

import { parseLocalDateTime } from "~/common/datetime";
import { buildLocale } from "~/common/locale";

export function FormatDate({
  className,
  ...props
}: Parameters<typeof formatDate>[0] & { className?: string }) {
  return <span className={className}>{formatDate(props)}</span>;
}

function formatDate({
  value,
  date = true,
  time = false,
}: {
  value: string | null;
  date?: boolean;
  time?: boolean;
}): string {
  if (!value) return "";
  if (date && time) {
    // Reuse the shared canonical local parse (common/datetime.ts) instead of re-deriving the `space→T`
    // replace here — same Date for any valid value, and a guarded "" (not "Invalid Date") for a bad one.
    const parsed = parseLocalDateTime(value);
    if (!parsed) return "";
    return parsed.toLocaleString(buildLocale, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  if (date) {
    return new Date(value).toLocaleDateString(buildLocale);
  }
  if (time) {
    return new Date(value).toLocaleTimeString(buildLocale);
  }
  return value;
}
